import React, { useEffect, useContext } from 'react';
import Loading from './Loading';
import getActivePlan from 'components/Settings/Utilities/getActivePlan';
import { store } from 'components/Store';
import { useLocation } from 'react-router-dom';
import getUrlParam, { getUrlParamRaw, decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import useGetAccessToken from 'components/Dashboard/apiCalls/useGetAccessToken';
import * as Sentry from '@sentry/react';
import LocalStorage from 'utils/LocalStorage';

const deleteURLParams = () => {
  let cookieItem = document.cookie.split('; ').find((row) => row.startsWith('utm_parameters='));
  if (cookieItem) {
    document.cookie = `utm_parameters=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=policymogul.com; path=/; Secure`;
  }
};

const LoginSuccess = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const { getAccessToken } = useGetAccessToken();

  const location = useLocation();
  const validationsCalls = async (source) => {
    try {
      let activePlan = await getActivePlan(getAccessToken, source);
      if (!!activePlan) {
        dispatch({ type: 'MODIFY_SECTION', parameter: 'activePlan', value: activePlan });
        const { userOnboarded } = activePlan ?? {}; //CHECK IF THE USER HAS CREATED THE FIRST LIST
        if (!userOnboarded) {
          return window.location.replace(`/create-your-profile/1${location.search}`);
        } else {
          if (getUrlParam('returnUrl') !== undefined) {
            let returnUrl = decodeUrlQueryValue(getUrlParamRaw('returnUrl'));
            let params = new URLSearchParams(location.search);
            params.delete('returnUrl');
            return window.location.replace(
              `${returnUrl}${
                params.toString() !== '' ? `${returnUrl.includes('?') ? '&' : '?'}` : ''
              }${params.toString()}`
            );
          } else {
            return window.location.replace(`/${location.search}`);
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    const source = new AbortController();
    deleteURLParams();
    // We need to remove the filters stored when you're logged out
    LocalStorage.removeItem('contentFilters');
    LocalStorage.removeItem('activeFilters');
    LocalStorage.removeItem('seeUnreadFilter');
    validationsCalls(source);
    return () => {
      source.abort('Active plan canceled by the user.');
    };
  }, []);
  return <Loading />;
};

export { deleteURLParams };
export default LoginSuccess;
